import { BaseError } from 'make-error';

export interface ApiFeature {
    name: string;
    is_player_enrolled: boolean;
}

export type ApiFeatures = Array<ApiFeature>;

export class FeatureEnrollmentPopulateError extends BaseError {
    details: Array<{ name: string; reason: string }>;

    constructor(message: string, reasons: Array<{ name: string; errorReason: string }>) {
        super(message);

        this.details = reasons.map((r) => {
            return { name: r.name, reason: r.errorReason };
        });
    }

    toString(): string {
        const msgStr = super.toString();
        const reasons = this.details.map((r) => `  - ${r.name}: ${r.reason}`);
        return [msgStr, '  Reasons:', ...reasons].join('\n');
    }
}
